<template>
  <c-dialog title="第三方账号绑定" :visible="visible" @close="visible=false" :append-to-body="true" width="720px">
    <template slot="content">
    <div style="padding-bottom:20px;float: right">
      <el-button type="info" @click="refetchData()" :disabled="fetching" size="small" icon="el-icon-refresh">刷新</el-button>
    </div>
    <!-- 数据列表 -->
    <el-table
      v-loading="fetching"
      :data="listData"
      row-key="id"
      element-loading-text="Loading"
      border
      fit
    >
      <el-table-column label="账号类型" align="center">
        <template slot-scope="{ row }">
          <span v-if="row.accountSource==='WECHAT'">微信</span>
          <span v-else-if="row.accountSource==='DOUYIN'">抖音</span>
        </template>
      </el-table-column>
      <el-table-column label="绑定状态" align="center">
        <template slot-scope="{ row }">
          <span v-if="row.status === 0">未绑定</span>
          <span v-else-if="row.status === 1">已绑定</span>
          <span v-else>-</span>
        </template>
      </el-table-column>
      <el-table-column label="是否过期" align="center">
        <template slot-scope="{ row }">
          <span v-if="row.isExpired" style="color:red">已过期</span>
          <span v-else-if="!row.isExpired" style="color:green">未过期</span>
          <span v-else>-</span>
        </template>
      </el-table-column>
      <el-table-column label="操作" align="center">
        <template slot-scope="{ row }">
          <el-button v-show="row.status === 0" type="primary" size="mini" @click="bindOnClick(row)">绑定账号</el-button>
          <el-button v-show="row.status === 1 && row.isExpired" type="primary" size="mini" @click="bindOnClick(row)">重新授权</el-button>
        </template>
      </el-table-column>
    </el-table>
    </template>
    <open-account-bind-wx v-model="showOpenAccountBindWx" @onClosed="openAccountBindWxOnClose"></open-account-bind-wx>
  </c-dialog>
</template>
<script>

import { Message } from 'element-ui'
import PermissionButton from '@/components/Buttons/permission-button'
import LoadingButton from '@/components/Buttons/loading-button'
import OpenAccountBindWx from './open-account-bind-wx'

export default {
  name: 'openAccount',
  components: {
    LoadingButton,
    PermissionButton,
    OpenAccountBindWx
  },
  props: {
    modelValue: Boolean
  },
  model: {
    prop: 'modelValue',
    event: 'update:modelValue'
  },
  watch: {
    modelValue: {
      handler (oldV, newV) {
        if (oldV) {
          this.fetchData()
        }
      }
    }
  },
  computed: {
    visible: {
      get () {
        return this.modelValue
      },
      set (val) {
        this.$emit('update:modelValue', val)
      }
    }
  },
  data () {
    return {
      /**
       * 列表
       */
      fetching: false,
      listData: [{
        id: 1,
        accountSource: 'WECHAT',
        status: 0,
        isExpired: false
      }, {
        id: 2,
        accountSource: 'DOUYIN',
        status: 0,
        isExpired: false
      }],
      showOpenAccountBindWx: false
    }
  },
  created () {
  },
  methods: {
    async fetchData () {
      this.fetching = true
      // 加入加载数据
      this.fetchOpenAccounts()
      this.fetching = false
    },
    async refetchData () {
      this.fetchData()
    },
    async bindOnClick (row) {
      if (row.accountSource === 'WECHAT') {
        this.showOpenAccountBindWx = true
      } else if (row.accountSource === 'DOUYIN') {
        this.$alert('暂未开放，敬请期待！', '温馨提醒', {
          confirmButtonText: '确定'
        })
      }
    },
    async fetchOpenAccounts () {
      try {
        const result = await this.$store.dispatch('MerchantAuth/getOpenAccounts')
        let openAccountMap = {}
        result.forEach(openAccount => {
          openAccountMap[openAccount.accountSource] = openAccount
        })
        this.listData.forEach(item => {
          const openAccount = openAccountMap[item.accountSource]
          if (!openAccount) {
            item.status = 0
            item.isExpired = true
          } else {
            item.status = 1
            item.isExpired = openAccount.isExpired
          }
        })
        console.log(this.listData)
      } catch (error) {
        Message({
          message: error.message,
          type: 'error',
          duration: 10 * 1000
        })
      }
    },
    async openAccountBindWxOnClose () {
      this.fetchData()
    }
  }
}

</script>

<style  lang="scss" scoped>

</style>



// WEBPACK FOOTER //
// src/views/system/components/open-account.vue